function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useRef, useState } from 'react';
import { debounce, groupBy, map } from 'lodash';
import { useFind } from '../api/ApiHooks';
var useClinicalModificationOptions = function useClinicalModificationOptions(query) {
  var _response$data$data, _response$data;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    code = _useState2[0],
    setCode = _useState2[1];
  var debounceSearch = useRef(debounce(setCode, 400)).current;
  useEffect(function () {
    debounceSearch(query);
    return function () {
      debounceSearch.cancel();
    };
  }, [debounceSearch, query]);
  var _useFind = useFind('clinical_modifications', {
      code: code
    }, {
      queryConfig: {
        enabled: !!code,
        placeholderData: undefined
      },
      page: {
        number: 1,
        size: 30
      }
    }),
    response = _useFind.data;
  var cmCodes = groupBy((_response$data$data = response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data) !== null && _response$data$data !== void 0 ? _response$data$data : [], 'code');
  var clinicalModificationOptions = map(cmCodes, function (val, key) {
    return {
      label: key,
      value: map(val, 'code').join(','),
      id: map(val, 'id').join(',')
    };
  });
  return clinicalModificationOptions;
};
export default useClinicalModificationOptions;
//# sourceMappingURL=useClinicalModificationOptions.js.map